import { render, staticRenderFns } from "./RecentHelpDesk.vue?vue&type=template&id=634db924&scoped=true"
import script from "./RecentHelpDesk.vue?vue&type=script&lang=js"
export * from "./RecentHelpDesk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634db924",
  null
  
)

export default component.exports